/* ==========================================================================
   Sprayo CRO — the customer clips.

   Each clip plays when it is on screen and stops when it is not, silent,
   looping. That is how the feeds these were filmed for behave, and it is the
   only autoplay a browser allows.

   Nothing is downloaded until a clip is about to be seen: the markup carries
   preload="none" and a poster, and the source is only fetched on the first
   play. A slider of eight clips therefore costs eight small images.
   ========================================================================== */

(function () {
  if (window.__sprayoUgc) return;
  window.__sprayoUgc = true;

  const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  function init() {
    const videos = document.querySelectorAll("[data-sprayo-ugc-video]");
    if (!videos.length) return;

    /* One video with sound at a time: turning a second one on silences the
       first, or two people talk over each other. */
    const silenceOthers = (keep) => {
      videos.forEach((v) => {
        if (v === keep) return;
        v.muted = true;
        const btn = v.parentElement.querySelector("[data-sprayo-ugc-sound]");
        if (btn) btn.classList.remove("is-on");
      });
    };

    /* The frame carries the playing state, so the glass button can hide
       itself in CSS instead of being toggled from three places. */
    videos.forEach((video) => {
      const frame = video.parentElement;

      /* The glass button means "make this audible", not merely "start it".
         A clip that autoplays on a phone is silent — a browser allows
         nothing else — so the button has to stay there, or there is nothing
         left to press for sound. It goes once the clip is audible, and once
         someone has chosen silence with the speaker, since then it would be
         arguing with them. */
      const mark = () => {
        const chose = frame.dataset.userMuted === "true";
        const audible = !video.paused && !video.muted;
        frame.classList.toggle("is-playing", audible || (chose && !video.paused));
      };
      video.addEventListener("play", mark);
      video.addEventListener("pause", mark);
      video.addEventListener("volumechange", mark);

      const play = frame.querySelector("[data-sprayo-ugc-play]");
      if (play) {
        play.addEventListener("click", (event) => {
          event.preventDefault();
          event.stopPropagation();
          frame.dataset.userMuted = "false";
          /* Pressing play means sound. Silent, the button looks like it did
             nothing. */
          silenceOthers(video);
          video.muted = false;
          const sound = frame.querySelector("[data-sprayo-ugc-sound]");
          if (sound) {
            sound.classList.add("is-on");
            sound.setAttribute("aria-label", sound.dataset.labelOn || "Turn sound off");
          }
          video.play().catch(() => {
            /* A browser that will not take sound from this gesture: silent
               is better than nothing happening. */
            video.muted = true;
            if (sound) sound.classList.remove("is-on");
            video.play().catch(() => {});
          });
        });
      }

      /* Pressing the clip itself pauses it, as a feed does. */
      video.addEventListener("click", () => {
        if (video.paused) {
          video.play().catch(() => {});
        } else if (video.muted && frame.dataset.userMuted !== "true") {
          /* Running but silent, and nobody asked for silence: the press is
             for sound, not for a pause. */
          silenceOthers(video);
          video.muted = false;
          const sound = frame.querySelector("[data-sprayo-ugc-sound]");
          if (sound) {
            sound.classList.add("is-on");
            sound.setAttribute("aria-label", sound.dataset.labelOn || "Turn sound off");
          }
        } else {
          video.pause();
        }
      });
    });

    videos.forEach((video) => {
      const button = video.parentElement.querySelector("[data-sprayo-ugc-sound]");
      if (!button) return;
      button.addEventListener("click", (event) => {
        event.preventDefault();
        event.stopPropagation();
        const on = video.muted;
        if (on) silenceOthers(video);
        video.muted = !on;
        /* Silence chosen deliberately stays chosen: no glass button comes
           back to ask again. */
        video.parentElement.dataset.userMuted = on ? "false" : "true";
        button.classList.toggle("is-on", on);
        button.setAttribute(
          "aria-label",
          on ? button.dataset.labelOn || "Turn sound off" : button.dataset.labelOff || "Turn sound on"
        );
        /* A muted autoplay that is unmuted by a tap keeps playing; one that
           was never started needs the tap to start it. */
        if (video.paused) video.play().catch(() => {});
      });
    });

    /* The arrows: one clip per press, retiring at each end. */
    document.querySelectorAll("[data-sprayo-ugc-scroller]").forEach((scroller) => {
      const track = scroller.querySelector("[data-sprayo-ugc-track]");
      const prev = scroller.querySelector("[data-sprayo-ugc-prev]");
      const next = scroller.querySelector("[data-sprayo-ugc-next]");
      if (!track || !prev || !next) return;

      const step = () => {
        const item = track.querySelector(".sprayo-ugc__item");
        return item ? item.getBoundingClientRect().width + 12 : track.clientWidth * 0.8;
      };
      prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
      next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));

      const ends = () => {
        const max = track.scrollWidth - track.clientWidth - 2;
        prev.hidden = track.scrollLeft <= 2;
        next.hidden = track.scrollLeft >= max;
      };
      track.addEventListener("scroll", ends, { passive: true });
      window.addEventListener("resize", ends);
      ends();
    });

    if (reduced) return;

    /* On a phone the clips are a slider: one is on screen and it plays. On a
       desktop they are a row of three, and three playing at once is three
       video decoders running for a section nobody has looked at yet — so
       there they wait for a pointer instead. */
    /* Decided by the layout, not the pointer: the same width at which the
       row becomes a grid. A laptop with a touchscreen reports both, and a
       phone in a desktop browser's device mode reports a mouse. */
    const hover = window.matchMedia("(min-width: 750px)").matches;
    if (hover) {
      videos.forEach((video) => {
        const frame = video.parentElement;
        frame.addEventListener("pointerenter", () => video.play().catch(() => {}));
        frame.addEventListener("pointerleave", () => {
          video.pause();
          video.muted = true;
          const btn = frame.querySelector("[data-sprayo-ugc-sound]");
          if (btn) btn.classList.remove("is-on");
        });
        /* A keyboard reaches the sound button; let it start the clip too. */
        frame.addEventListener("focusin", () => video.play().catch(() => {}));
      });
      return;
    }

    /* One clip plays: the one nearest the middle of the track, chosen once
       the swipe has settled.

       It used to be an IntersectionObserver at threshold 0.6 per video. Two
       clips are partly on screen at any moment, so during a swipe each one
       crossed 0.6 in and out repeatedly — every crossing calling play(),
       then pause() and rewinding to zero. That start-stop-rewind is the
       flicker, and at the halfway point two clips ran at once.

       Position is read after scrolling stops rather than reacted to while it
       happens, so a swipe changes what plays exactly once. */
    const settleFor = (track) => {
      const items = Array.from(track.querySelectorAll(".sprayo-ugc__item"));
      if (!items.length) return;

      const centred = () => {
        const box = track.getBoundingClientRect();
        const mid = box.left + box.width / 2;
        let best = null;
        let bestGap = Infinity;
        items.forEach((item) => {
          const b = item.getBoundingClientRect();
          const gap = Math.abs(b.left + b.width / 2 - mid);
          if (gap < bestGap) {
            bestGap = gap;
            best = item;
          }
        });
        return best;
      };

      /* The clip either side of the centred one is told to fetch its first
         frames, so a swipe hands play to something already decoding rather
         than to a cold element at readyState 0. Only the neighbours: eight
         clips warming at once is the cost preload="none" exists to avoid. */
      const warm = (winner) => {
        const at = items.indexOf(winner);
        [at - 1, at + 1].forEach((ix) => {
          const item = items[ix];
          if (!item) return;
          const video = item.querySelector("[data-sprayo-ugc-video]");
          if (!video || video.readyState > 0 || video.dataset.warmed) return;
          video.dataset.warmed = "1";
          video.preload = "metadata";
          video.load();
        });
      };

      const focus = () => {
        const winner = centred();
        if (winner) warm(winner);
        items.forEach((item) => {
          const video = item.querySelector("[data-sprayo-ugc-video]");
          if (!video) return;
          if (item === winner) {
            video.play().catch(() => {});
            return;
          }
          if (video.paused) return;
          video.pause();
          /* Rewound only when it is nowhere near the middle, so nudging the
             track a few pixels does not throw away what someone is watching. */
          const b = item.getBoundingClientRect();
          const box = track.getBoundingClientRect();
          const far = Math.abs(b.left + b.width / 2 - (box.left + box.width / 2)) > box.width * 0.75;
          if (far && video.currentTime > 0.2) video.currentTime = 0;
          video.muted = true;
          item.querySelector(".sprayo-ugc__media").dataset.userMuted = "false";
          const btn = item.querySelector("[data-sprayo-ugc-sound]");
          if (btn) btn.classList.remove("is-on");
        });
      };

      let timer;
      const settle = () => {
        clearTimeout(timer);
        timer = setTimeout(focus, 120);
      };
      track.addEventListener("scroll", settle, { passive: true });

      /* Nothing runs until the section is actually on screen, and everything
         stops when it leaves — a decoder per clip is not free. */
      const section = track.closest(".sprayo-ugc") || track;
      new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              focus();
            } else {
              items.forEach((item) => {
                const video = item.querySelector("[data-sprayo-ugc-video]");
                if (video && !video.paused) video.pause();
              });
            }
          });
        },
        { threshold: 0.25 }
      ).observe(section);
    };

    document.querySelectorAll("[data-sprayo-ugc-track]").forEach(settleFor);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
